import type { ReactElement } from 'react';
import { IconPatients } from '@adc/parallax-icons';

import ArchiveIcon from '~/icons/archive.svg?react';
import KeyboardIcon from '~/icons/keyboard.svg?react';
import type { FileRouteTypes } from '~/routeTree.gen';
import { buildTestId } from '~/utils/buildTestId';

const APP_MENU_TEST_ID = 'app-menu-item';

export const APP_MENU_ITEMS = {
  CustomerAdministration: {
    id: 'customer-administration',
    label: 'Customer Administration',
    testID: buildTestId({
      testID: APP_MENU_TEST_ID,
      suffix: ['customer', 'administration'],
    }),
  },
  AbbottAdministration: {
    id: 'abbott-administration',
    label: 'Abbott Administration',
    testID: buildTestId({
      testID: APP_MENU_TEST_ID,
      suffix: ['abbott', 'administration'],
    }),
  },
  Education: {
    id: 'education',
    label: 'Education',
    testID: buildTestId({
      testID: APP_MENU_TEST_ID,
      suffix: 'education',
    }),
  },
  Outpatient: {
    id: 'outpatient',
    label: 'Patients',
    testID: buildTestId({
      testID: APP_MENU_TEST_ID,
      suffix: 'outpatient',
    }),
  },
  Administration: {
    id: 'administration',
    label: 'Administration',
    testID: buildTestId({
      testID: APP_MENU_TEST_ID,
      suffix: 'administration',
    }),
  },
} as const;

const NAVIGATION_TEST_ID = 'navigation-item';

type ItemType = {
  id: string;
  label: string;
  path: FileRouteTypes['to'];
  icon: ReactElement;
  testID: string;
};

export const NAVIGATION_MENU_ITEMS = {
  AbbottUserAdministration: {
    id: 'abbott-user-administration',
    label: 'Users',
    icon: <IconPatients />,
    path: '/abbott-admin/abbott',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: ['abbott', 'administration'],
    }),
  } satisfies ItemType,
  UserAdministration: {
    id: 'user-administration',
    label: 'User Administration',
    icon: <IconPatients />,
    path: '/hcp-admin/users',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: ['user', 'administration'],
    }),
  } satisfies ItemType,
  CustomerUserAdministration: {
    id: 'user-administration',
    label: 'Users',
    icon: <IconPatients />,
    path: '/customer-admin/users',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: ['user', 'administration'],
    }),
  } satisfies ItemType,
  PatientAdministration: {
    id: 'patients',
    label: 'Patients',
    icon: <IconPatients />,
    path: '/outpatient/patients',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: 'patients',
    }),
  } satisfies ItemType,
  PatientsCustomerAdministration: {
    id: 'patients',
    label: 'Patients',
    icon: <IconPatients />,
    path: '/customer-admin/patients',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: 'patients',
    }),
  } satisfies ItemType,
  Departments: {
    id: 'departments',
    label: 'Departments',
    icon: <ArchiveIcon />,
    path: '/customer-admin/departments',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: 'departments',
    }),
  } satisfies ItemType,
  DepartmentsAndSettings: {
    id: 'departments',
    label: 'Departments & Settings',
    icon: <ArchiveIcon />,
    path: '/hcp-admin/departments',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: 'departments',
    }),
  } satisfies ItemType,
  Archive: {
    id: 'archive',
    label: 'Archive',
    icon: <ArchiveIcon />,
    path: '/hcp-admin/archive',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: 'archive',
    }),
  } satisfies ItemType,
  IDNS: {
    id: 'idns',
    label: 'IDNs',
    icon: <KeyboardIcon />,
    path: '/customer-admin/idns',
    testID: buildTestId({
      testID: NAVIGATION_TEST_ID,
      suffix: 'idns',
    }),
  } satisfies ItemType,
} as const;
